import React, {useEffect} from 'react';
import { Link } from 'react-router-dom';


function trackClick( event )
{
  const dataLayer = window.PMNdataLayer;
  const eventData = {
    'event': 'misc_event',
    'eventAction': 'click',
    'eventLabel': event
  }

  if( dataLayer )
    window.PMNdataLayer.push( eventData )
  else
    console.log( 'Would log', eventData, 'if I was live');
}

function TrackingLink( props ) {
  const handleClick = () => {
    trackClick( props.event );
  };

  const link = "href" in props
    ? <a onClick={ handleClick } {...props}/>
  : <Link onClick={ handleClick } {...props}/>


  return (
    <>{ link }</>
  );
}


export { TrackingLink, trackClick }
